export enum PropertySuffix {
  FEATURE_FLAG = '_feature_flag',
  TAB_NOTIFICATION_ENUM = '_tab_notification_enum',
  MIN_CARDINALITY = '_minCardinality',
  MAX_CARDINALITY = '_maxCardinality',
  MIN = '_min',
  MAX = '_max',
  OPTIONS = '_options',
  LABELS = '_labels',
  FILTERABLE = '_filterable',
  KB_LINK = '_fflag_kb_link',
  RELATION_TYPE_URI = '_relation_type_uri',
  RECOMMENDATIONS_COUNT = '_recommendations_count',
  RECOMMENDATIONS_MAX = '_recommendations_max',
  GROWTH_MAPPING = '_growthMapping',
  SYNC = '_sync'
}
